import { nanoid } from "nanoid"
import { Skeleton } from "primereact/skeleton"

const ArticuloSkeleton = ({ isGrid }: { isGrid: boolean }) =>
  isGrid ? (
    <div className='tw-w-full tw-flex tw-flex-col tw-p-6 tw-h-auto tw-shadow'>
      <Skeleton
        height='192px'
        className='tw-w-full tw-pb-3 tw-mb-2.5'
      />
      <Skeleton className='tw-w-full' />
      <div className='tw-full tw-flex tw-flex-row tw-justify-between tw-mt-2'>
        <Skeleton
          width='50%'
          className=' tw-mr-1'
        />
        <Skeleton
          width='50%'
          className='tw-ml-1'
        />
      </div>

      <Skeleton
        height='48px'
        className='tw-mt-2 tw-w-full !tw-rounded'
      />
    </div>
  ) : (
    <div className='tw-w-full tw-flex tw-flex-row tw-p-6 tw-h-32 tw-items-center tw-shadow'>
      <Skeleton
        height='80px'
        width='80px'
      />
      <Skeleton
        width='120px'
        height='24px'
        className='tw-ml-2'
      />
      <Skeleton
        className='tw-flex-wrap tw-ml-2'
        height='24px'
      />

      <Skeleton
        width='120px'
        height='24px'
        className='tw-ml-2'
      />
      <Skeleton
        width='120px'
        height='24px'
        className='tw-ml-2'
      />
    </div>
  )

export const ArticulosSkeletons = ({ isGrid }: { isGrid: boolean }) => {
  return [...new Array(isGrid ? 20 : 10).keys()].map(() => (
    <ArticuloSkeleton
      key={nanoid()}
      isGrid={isGrid}
    />
  ))
}
